import { Img } from "@/components/ui/image"

const SnaiLogo = () => {
  return (
    <>
      <Img
        src="/assets/logo/logo-snai.svg"
        alt="logo"
        width={74}
        height={19}
        className="hidden max-h-7 w-auto md:block"
      />
      <Img
        src="/assets/logo/logo-snai-mobile.svg"
        alt="logo"
        width={32}
        height={28}
        className="block max-h-7 w-auto md:hidden"
      />
    </>
  )
}

export { SnaiLogo }
